import styled from "styled-components";

export const StyledFlag = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;
